module.exports = __webpack_public_path__ + "img/637025886387336572output-onlinepngtools.png";